import { motion, useInView, useAnimation } from "framer-motion";
import data from "../data.json";
import { SocialIcon } from "react-social-icons";
import { IoLocation } from "react-icons/io5";
import { FaMobile } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useRef, useEffect } from "react";

const Contact = ({ refContact }) => {
    const ref = useRef(null);
    const isInView = useInView(ref)
    const mainControlls = useAnimation();
    useEffect(() => {
        if (isInView) {
            mainControlls.start("visible")
        }
        else {
            mainControlls.start("hidden")
        }

    }, [isInView,mainControlls])
    return (
        <div className="item" style={{marginBottom:"0rem",height:"fit-content"}} ref={refContact}>
            <div ref={ref}>

                <motion.div className="projects-motion" variants={{
                    hidden: { opacity: 0, x: 100 },
                    visible: { opacity: 1, x: 0 }
                }}
                    initial="hidden"
                    animate={mainControlls}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    whileHover={{ scale: 1 }}
                    style={{height:"fit-content",paddingBottom:"0rem"}}
                    >
                    <div className="item-title">Contact Me</div>
                    <div className="projects-item" style={{ display: "flex" }}>
                        <div style={{width:"30%"}}>
                            <img src="contact-removebg-preview.png" alt="contactme" style={{  height:"70%", marginRight:"10rem" }}></img>
                            {/* <iframe src={data.Contact.mapURL} width="100%"  height="100%" style={{border:0,borderRadius:"0rem"}}  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                        </div>
                        <div className="contact-content">
                            <h2 className="dancing-script-title">&lt;Reach out to me at anytime <span style={{color:"red"}}>❤</span>!&gt;</h2>
                            <div >
                                <p style={{ fontSize: "20px", marginBottom: "0rem", marginTop: "0.3rem" }}><a style={{textDecoration:"none",color:"white"}} href="https://maps.app.goo.gl/LT9Gs8vmD75xu7ba9" target="_blank" rel="noreferrer"><IoLocation/> </a> <span style={{ marginLeft: "1rem" }}>Warangal,Telangana</span></p>
                                <p style={{ fontSize: "20px", marginBottom: "0rem", marginTop: "0.3rem" }}><FaMobile />   <span style={{ marginLeft: "1rem" }}>+91 8555054818</span></p>
                                <p style={{ fontSize: "20px", marginBottom: "0rem", marginTop: "0.3rem" }}><MdEmail />   <span style={{ marginLeft: "1rem" }}>gajulapallyabhilash@gmail.com</span></p>
                            </div>
                            <div style={{ marginTop: "2rem", display: "flex" }}>
                                {data.about.links.map((e) => {
                                    return (
                                        <motion.div
                                            initial={{ rotate: 0 }}
                                            whileHover={{ scale:1 }}

                                        >
                                            <SocialIcon url={e.link} network={e.platform} style={{ marginRight: "1rem", height: "4rem", width: "4rem" }} />
                                        </motion.div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default Contact;